import axios from 'axios';

interface ServerResponse {
  Items: GeoItem[] | Error[];
}

interface Error {
  Cause: string;
  Description: string;
  Error: string;
  Resolution: string;
}

interface GeoItem {
  Postcode: string;
  Distance: number;
  Easting: number;
  Northing: number;
  Latitude: number;
  Longitude: number;
  OsGrid: string;
}

interface GetAddressFromLocationParams {
  latitude: number;
  longitude: number;
}

const useReverGeoLocation = () => {
  const client = axios.create({
    baseURL: import.meta.env.VITE_REVERSE_GEOLOCATION,
    params: {
      Key: import.meta.env.VITE_LOQATE_API_KEY,
    },
  });

  const getAddressFromLocation = async ({ latitude, longitude }: GetAddressFromLocationParams) => {
    const params = {
      CentrePoint: `${latitude},${longitude}`,
    };

    const result = await client.get<ServerResponse>('json3.ws', {
      params,
    });

    if (result.data.Items.length) {
      if ('Error' in result.data.Items[0]) {
        return null;
      }
      return result.data.Items[0] || null;
    }

    return null;
  };

  return { getAddressFromLocation };
};

export default useReverGeoLocation;
